export const actionTypes = {
    CHAGE: 'CHANGE_LOADING'
}

export const changeLoadingIcon = (payLoad) =>({
    type: actionTypes.CHAGE,
    payLoad
})